import ApiBase from './api_base'
import lodash from 'lodash'

export default class UserApi {
  static captcha(params) {
    return ApiBase.post('/captchas',
      lodash.pick(params, ['cellphone', 'reset']))
  }

  static show() {
    return ApiBase.get('/profile')
  }

  static update(params) {
    return ApiBase.put('/profile', {
      user: lodash.pick(params, ['cellphone', 'nickname']),
      captcha: params.captcha
    })
  }

  static signUp(params) {
    return ApiBase.post('/users', {
      user: lodash.pick(params, ['email', 'password', 'cellphone', 'sign_up_ref']),
      captcha: params.captcha
    })
  }

  static signIn(params) {
    return ApiBase.post('/users/sign_in', {
      user: lodash.pick(params, ['login', 'password'])
    })
  }

  static signOut() {
    return ApiBase.delete('/users/sign_out')
  }

  static changePassword(params) {
    return ApiBase.put('/users', lodash.pick(params, ['current_password', 'password']))
  }

  static reqResetPassword(params) {
    // according to params.findType, filter params
    return ApiBase.post('/users/password', params.findType === 'email' ? lodash.pick(params, ['email']) : lodash.pick(params, ['cellphone', 'captcha']))
  }

  static resetPassword(params) {
    return ApiBase.put('/users/password', lodash.pick(params, ['reset_password_token', 'password']))
  }

  static wxConnection() {
    return ApiBase.get('/authentications/connect_qrcode')
  }

  static wxDisconnect() {
    return ApiBase.delete('/authentications/wechat/disconnect')
  }

  static wxAuth() {
    return ApiBase.get('/auth/wechat_web.json')
  }
}



// WEBPACK FOOTER //
// ./src/api/user.js